export default "__VITE_ASSET__BCDmtY0N__"